var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderTrace',{attrs:{"admin-view":false,"visitor-view":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }